import { type PropsWithChildren } from 'react';

import { BrandContext } from '~/modules/branding';
import { BRANDS } from '~/modules/branding/brands';
import { ADA_DOMAINS, WMG_DOMAINS } from '~/modules/branding/constants';
import { isValidBrand } from '~/modules/branding/utils/isValidBrand';
import { ErrorDisplay } from '~/modules/label-perf/containers/LabelPerf/components';

import type { Brand, BrandType } from '../types';

export interface BrandProviderProps {
  localBrand?: BrandType;
  hostname: string;
}

export function BrandProvider({
  children,
  localBrand,
  hostname,
}: PropsWithChildren<BrandProviderProps>) {
  // NOTE: The returned brand object is static so there is no need for useMemo here.
  let brand: Brand | null = null;

  if (isValidBrand(localBrand)) {
    brand = localBrand === 'WMG' ? BRANDS.WMG : BRANDS.ADA;
  } else if ((ADA_DOMAINS as readonly string[]).includes(hostname)) {
    brand = BRANDS.ADA;
  } else if ((WMG_DOMAINS as readonly string[]).includes(hostname)) {
    brand = BRANDS.WMG;
  }

  if (!brand) {
    return (
      <ErrorDisplay
        title="Brand Not Found"
        description={`Couldn't determine Brand for localBrand[${localBrand}] and hostname[${hostname}]`}
      />
    );
  }

  return (
    <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
  );
}

BrandProvider.displayName = 'BrandProvider';
